import { Palette } from 'lucide-react';
import { FilterStringConfig } from 'v5/patterns/filters/FilterWidget.types';

export function createProductionColorFilterConfig(): FilterStringConfig {
  return {
    label: 'Color',
    icon: <Palette />,
    type: 'string',
    createDefaultValue: () => ({ operator: 'contains', value: '' })
  };
}
